import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import ViewStudentComp from './ViewStudentComp' 

function ViewStudent() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <ViewStudentComp/>       
        </div>
    </div>
  )
}

export default ViewStudent